interface IEnvConfig {
  PORT: string;
  NODE_ENV: string;
  PM_GRAPH: string;
  RT_CLUSTER_GRAPH: string;
  DIGGER_API_KEY_V2: string;
  DIGGER_BASE_URL: string;
  BRAND_ID: string;
  POSTHOG_API_KEY: string;
  CDN_HOST: string;
}

export const ENV_CONFIG: IEnvConfig = {
  PORT: process.env.PORT || '',
  NODE_ENV: process.env.NODE_ENV || '',
  PM_GRAPH: process.env.PM_GRAPH || '',
  RT_CLUSTER_GRAPH: process.env.RT_CLUSTER_GRAPH || '',
  DIGGER_API_KEY_V2: process.env.DIGGER_API_KEY_V2 || '',
  DIGGER_BASE_URL: process.env.DIGGER_BASE_URL || '',
  BRAND_ID: process.env.BRAND_ID || '',
  POSTHOG_API_KEY: process.env.POSTHOG_API_KEY || '',
  CDN_HOST: process.env.CDN_HOST || 'https://cdn-prod.reeltime.no/'
};
